/* PDP: aggiornamento badge disponibilità e spazio "Avvisami" al cambio variante.
   Si aggancia all'evento esistente product:variant-change (nessun fetch, nessuna libreria). */
(function () {
  // Guardia contro la doppia inizializzazione (file incluso più volte)
  if (window.__pdpAvailabilityInit) return;
  window.__pdpAvailabilityInit = true;

  var STATI = ['ok', 'low', 'out', 'preorder'];
  var cacheMappe = new WeakMap();

  // Legge e memorizza la mappa JSON vicina al badge
  function leggiMappa(badge) {
    if (cacheMappe.has(badge)) return cacheMappe.get(badge);
    var mappa = null;
    var script = badge.querySelector('[data-pdp-availability-map]');
    if (script) {
      try {
        mappa = JSON.parse(script.textContent);
      } catch (e) {
        mappa = null;
      }
    }
    cacheMappe.set(badge, mappa);
    return mappa;
  }

  function aggiornaBadge(badge, voce) {
    if (!voce || STATI.indexOf(voce.state) === -1) return;
    STATI.forEach(function (s) {
      badge.classList.remove('pdp-availability--' + s);
    });
    badge.classList.add('pdp-availability--' + voce.state);
    badge.setAttribute('data-state', voce.state);
    var etichetta = badge.querySelector('.pdp-availability__label');
    if (etichetta && typeof voce.label === 'string') etichetta.textContent = voce.label;
  }

  // "Avvisami" visibile solo con stato out
  function aggiornaAvvisami(sectionId, stato) {
    var blocchi = document.querySelectorAll('[data-pdp-notify]');
    Array.prototype.forEach.call(blocchi, function (el) {
      if (el.getAttribute('data-section') !== String(sectionId)) return;
      el.hidden = stato !== 'out';
    });
  }

  // Allinea la classe sold-out dei pulsanti (CTA e barra sticky): toggleAddButton() la aggiunge ma non la toglie mai
  function aggiornaSoldOut(sectionId, variante) {
    var esaurita = !variante || !variante.available;
    var id = String(sectionId).replace(/["\\]/g, '');
    var pulsanti = document.querySelectorAll(
      '[id="product-form-' + id + '"] .single-add-to-cart-button, ' +
      'product-add-to-cart-sticky[data-section="' + id + '"] .single-add-to-cart-button'
    );
    Array.prototype.forEach.call(pulsanti, function (pulsante) {
      pulsante.classList.toggle('sold-out', esaurita);
    });
  }

  function onVariantChange(event) {
    var detail = event.detail || {};
    var sectionId = detail.sectionId;
    if (sectionId === undefined || sectionId === null) return;
    var variante = detail.variant;
    var statoFinale = null;

    var badges = document.querySelectorAll('[data-pdp-availability]');
    Array.prototype.forEach.call(badges, function (badge) {
      if (badge.getAttribute('data-section') !== String(sectionId)) return;
      var mappa = leggiMappa(badge);
      if (!mappa) return;
      var chiave = variante && variante.id !== undefined ? String(variante.id) : 'unavailable';
      var voce = mappa[chiave] || mappa.unavailable;
      aggiornaBadge(badge, voce);
      if (voce) statoFinale = voce.state;
    });

    // Senza badge (impostazione disattivata) si ricava lo stato dalla variante
    if (statoFinale === null) statoFinale = variante && variante.available ? 'ok' : 'out';
    aggiornaAvvisami(sectionId, statoFinale);
    aggiornaSoldOut(sectionId, variante);
  }

  document.addEventListener('product:variant-change', onVariantChange);

  // Nell'editor la sezione viene ridisegnata: azzera la cache delle mappe
  document.addEventListener('shopify:section:load', function () {
    cacheMappe = new WeakMap();
  });
})();
